import { render, staticRenderFns } from "./InspectionRemark.vue?vue&type=template&id=66513808&"
import script from "./InspectionRemark.vue?vue&type=script&lang=ts&"
export * from "./InspectionRemark.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports